

// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";

// const styles = StyleSheet.create({
//   page: {
//     paddingTop: 75,
//     paddingBottom: 95,
//     paddingHorizontal: 25,
//     fontSize: 9,
//     backgroundColor: "#FFFFFF",
//   },

//   /* ── HEADER ── */
//   headerWrapper: {
//     position: "absolute",
//     top: 8,
//     left: 25,
//     right: 25,
//     height: 60,
//   },
//   headerImage: {
//     width: "100%",
//     height: 60,
//     objectFit: "contain",
//   },

//   /* ── FOOTER ── */
//   footerWrapper: {
//     position: "absolute",
//     bottom: 8,
//     left: 25,
//     right: 25,
//     height: 72,
//     width: "100%"
//   },
//   footerImage: {
//     width: "100%",
//     height: 72,
//     objectFit: "contain",
//   },

//   /* ── TITLE ── */
//   title: {
//     fontSize: 14,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 12,
//   },

//   /* ── TABLE OUTER BORDER (all 4 sides) ── */
//   table: {
//     width: "100%",
//     borderTopWidth: 1,
//     borderLeftWidth: 1,
//     borderRightWidth: 1,
//     borderBottomWidth: 1,
//     borderColor: "#000000",
//     borderStyle: "solid",
//   },

//   /* ── ROWS ── */
//   tableRow: {
//     flexDirection: "row",
//     borderBottomWidth: 1,
//     borderBottomColor: "#000000",
//     borderBottomStyle: "solid",
//     minHeight: 26,
//     alignItems: "stretch",
//   },

//   lastRow: {
//     borderBottomWidth: 0,
//   },

//   headerRow: {
//     backgroundColor: "#EAEAEA",
//   },

//   /* ── HEADER CELLS ── */
//   cellHeader: {
//     paddingVertical: 6,
//     paddingHorizontal: 5,
//     fontWeight: "bold",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderRightColor: "#000000",
//     borderRightStyle: "solid",
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   /* ── DATA CELLS ── */
//   cell: {
//     paddingVertical: 5,
//     paddingHorizontal: 5,
//     borderRightWidth: 1,
//     borderRightColor: "#000000",
//     borderRightStyle: "solid",
//     justifyContent: "center",
//   },

//   /* last column — no right border (table border covers it) */
//   lastCell: {
//     borderRightWidth: 0,
//   },

//   /* ── COLUMN WIDTHS ── */
//   slNo: {
//     width: 32,
//     textAlign: "center",
//   },
//   standard: {
//     width: 165,
//     textAlign: "left",
//   },
//   student: {
//     width: 140,
//     textAlign: "left",
//   },
//   date: {
//     width: 82,
//     textAlign: "center",
//   },
//   amount: {
//     width: 85,
//     textAlign: "right",
//   },
//   due: {
//     width: 75,
//     textAlign: "right",
//   },
//   status: {
//     flex: 1,
//     textAlign: "center",
//   },

//   /* ── PAGE NUMBER ── */
//   pageNumber: {
//     position: "absolute",
//     bottom: 83,
//     left: 0,
//     right: 0,
//     textAlign: "center",
//     fontSize: 8,
//     color: "#555555",
//   },
// });

// const FIRST_PAGE_COUNT = 8;
// const OTHER_PAGE_COUNT = 10;

// const paginateData = (data) => {
//   const pages = [];
//   pages.push(data.slice(0, FIRST_PAGE_COUNT));
//   for (let i = FIRST_PAGE_COUNT; i < data.length; i += OTHER_PAGE_COUNT) {
//     pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
//   }
//   return pages;
// };

// const safe = (val) =>
//   val !== null && val !== undefined ? String(val) : "";

// const Teacherspdf = ({ data = [], filters = {} }) => {
//   const pages = paginateData(data);

//   return (
//     <Document>
//       {pages.map((pageData, pageIndex) => (
//         <Page
//           key={pageIndex}
//           size="A4"
//           orientation="landscape"
//           style={styles.page}
//         >
//           {/* ══ HEADER ══ */}
//           <View fixed style={styles.headerWrapper}>
//             {filters.HeaderImg ? (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
//                 style={styles.headerImage}
//               />
//             ) : null}
//           </View>

//           {/* ══ TITLE (page 1 only) ══ */}
//           {pageIndex === 0 && (
//             <Text style={styles.title}>
//               Teacher Invoice - {safe(filters.EmployeeID)}
//             </Text>
//           )}

//           {/* ══ TABLE ══ */}
//           <View
//             style={[
//               styles.table,
//               pageIndex !== 0 && { marginTop: 10 },
//             ]}
//           >
//             {/* ── HEADER ROW ── */}
//             <View style={[styles.tableRow, styles.headerRow]}>
//               <Text style={[styles.cellHeader, styles.slNo]}>
//                 SL#
//               </Text>
//               <Text style={[styles.cellHeader, styles.standard]}>
//                 Teachers
//               </Text>
//               <Text style={[styles.cellHeader, styles.student]}>
//                 Subjects
//               </Text>
//               <Text style={[styles.cellHeader, styles.date]}>
//                 Gender
//               </Text>
//               <Text style={[styles.cellHeader, styles.amount]}>
//                 Mobile Number
//               </Text>
//               <Text style={[styles.cellHeader, styles.amount]}>
//                 Email
//               </Text>
//               {/* <Text style={[styles.cellHeader, styles.due]}>
//                 Due
//               </Text> */}
//               {/* <Text
//                 style={[
//                   styles.cellHeader,
//                   styles.status,
//                   styles.lastCell,
//                 ]}
//               >
//                 Status
//               </Text> */}
//             </View>

//             {/* ── DATA ROWS ── */}
//             {pageData.map((row, rowIndex) => {
//               const isLastRow = rowIndex === pageData.length - 1;
//               const globalIndex =
//                 pageIndex === 0
//                   ? rowIndex + 1
//                   : FIRST_PAGE_COUNT +
//                     (pageIndex - 1) * OTHER_PAGE_COUNT +
//                     rowIndex +
//                     1;

//               return (
//                 <View
//                   key={rowIndex}
//                   style={[
//                     styles.tableRow,
//                     isLastRow && styles.lastRow,
//                   ]}
//                 >
//                   <Text style={[styles.cell, styles.slNo]}>
//                     {globalIndex}
//                   </Text>
//                   <Text style={[styles.cell, styles.standard]}>
//                     {safe(row.EmpName)}
//                   </Text>
//                   <Text style={[styles.cell, styles.student]}>
//                     {safe(row.DeptName)}
//                   </Text>
//                   <Text style={[styles.cell, styles.date]}>
//                     {safe(row.Gender)}
//                   </Text>
//                   <Text style={[styles.cell, styles.amount]}>
//                     {safe(row.MobileNumber)}
//                   </Text>
//                   <Text style={[styles.cell, styles.amount]}>
//                     {safe(row.Email)}
//                   </Text>
//                   {/* <Text style={[styles.cell, styles.due]}>
//                     {safe(row.Due)}
//                   </Text>
//                   <Text
//                     style={[
//                       styles.cell,
//                       styles.status,
//                       styles.lastCell,
//                     ]}
//                   >
//                     {safe(row.PaymentStatus)}
//                   </Text> */}
//                 </View>
//               );
//             })}
//           </View>

//           {/* ══ PAGE NUMBER ══ */}
//           <Text
//             style={styles.pageNumber}
//             render={({ pageNumber, totalPages }) =>
//               `Page ${pageNumber} of ${totalPages}`
//             }
//             fixed
//           />

//           {/* ══ FOOTER ══ */}
//           <View fixed style={styles.footerWrapper}>
//             {filters.FooterImg ? (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
//                 style={styles.footerImage}
//               />
//             ) : null}
//           </View>
//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default Teacherspdf;
import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

// A4 Landscape usable width = 841 - 2*25 (padding) = 791pt
// Column widths must sum to exactly 791
// SL#=30, Teachers=160, Subjects=130, Gender=70, Mobile=110, Email=291 → total=791

const COL = {
  slNo:    30,
  teacher: 160,
  subject: 130,
  gender:  70,
  mobile:  110,
  email:   491,   // flex remainder
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 75,
    paddingBottom: 95,
    paddingHorizontal: 25,
    fontSize: 9,
    backgroundColor: "#FFFFFF",
  },

  /* ── HEADER ── */
  headerWrapper: {
    position: "absolute",
    top: 8,
    left: 25,
    right: 25,
    height: 60,
  },
  headerImage: {
    width: "100%",
    height: 60,
    objectFit: "contain",
  },

  /* ── FOOTER ── */
//   footerWrapper: {
//     position: "absolute",
//     bottom: 8,
//     left: 25,
//     right: 25,
//     height: 72,
//     width: "100%"
//   },
//   footerImage: {
//     width: "100%",
//     height: 72,
//     objectFit: "contain",
//   },
footerWrapper: {
  position: "absolute",
  bottom: 0,           // flush to page bottom
  left: 0,             // flush to page left edge
  right: 0,            // flush to page right edge
  height: 80,          // increase height so image is fully visible
},
footerImage: {
  width: "100%",
  height: 80,          // match footerWrapper height
  objectFit: "fill",   // stretch to fill full width
},

  /* ── TITLE ── */
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 12,
  },

  /* ── TABLE ── */
  table: {
    width: "100%",
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 0,
    borderColor: "#000000",
    borderStyle: "solid",
  },

  /* ── ROW ── */
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    alignItems: "stretch",
  },

  headerRow: {
    backgroundColor: "#EAEAEA",
    minHeight: 30,
  },

  dataRow: {
    minHeight: 26,
  },

  /* ── BASE CELL ── */
  cellBase: {
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    justifyContent: "center",
  },

  lastCell: {
    borderRightWidth: 0,
  },

  /* ── COLUMN FIXED WIDTHS ── */
  cSlNo:    { width: COL.slNo    },
  cTeacher: { width: COL.teacher },
  cSubject: { width: COL.subject },
  cGender:  { width: COL.gender  },
  cMobile:  { width: COL.mobile  },
  cEmail:   { width: COL.email   },

  /* ── ALIGNMENT ── */
  aCenter: { textAlign: "center" },
  aLeft:   { textAlign: "left"   },
  aRight:  { textAlign: "right"  },

  /* ── HEADER CELL EXTRA ── */
  cellHeaderText: {
    fontWeight: "bold",
    textAlign: "center",     // ALL headers centered
  },

  /* ── PAGE NUMBER ── */
  pageNumber: {
    position: "absolute",
    bottom: 83,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
    color: "#555555",
  },
});

const FIRST_PAGE_COUNT = 8;
const OTHER_PAGE_COUNT = 10;

const paginateData = (data) => {
  const pages = [];
  pages.push(data.slice(0, FIRST_PAGE_COUNT));
  for (let i = FIRST_PAGE_COUNT; i < data.length; i += OTHER_PAGE_COUNT) {
    pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
  }
  return pages;
};

const safe = (val) =>
  val !== null && val !== undefined ? String(val).trim() : "";

// Header row — 6 columns, all centered
const TableHeader = () => (
  <View style={[styles.tableRow, styles.headerRow]}>
    <View style={[styles.cellBase, styles.cSlNo]}>
      <Text style={styles.cellHeaderText}>SL#</Text>
    </View>
    <View style={[styles.cellBase, styles.cTeacher]}>
      <Text style={styles.cellHeaderText}>Teachers</Text>
    </View>
    <View style={[styles.cellBase, styles.cSubject]}>
      <Text style={styles.cellHeaderText}>Subjects</Text>
    </View>
    <View style={[styles.cellBase, styles.cGender]}>
      <Text style={styles.cellHeaderText}>Gender</Text>
    </View>
    <View style={[styles.cellBase, styles.cMobile]}>
      <Text style={styles.cellHeaderText}>Mobile Number</Text>
    </View>
    <View style={[styles.cellBase, styles.cEmail, styles.lastCell]}>
      <Text style={styles.cellHeaderText}>Email</Text>
    </View>
  </View>
);

const Teacherspdf = ({ data = [], filters = {} }) => {
  const pages = paginateData(data);

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          orientation="landscape"
          style={styles.page}
        >
          {/* ══ HEADER ══ */}
          <View fixed style={styles.headerWrapper}>
            {filters.HeaderImg ? (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                style={styles.headerImage}
              />
            ) : null}
          </View>

          {/* ══ TITLE (page 1 only) ══ */}
          {pageIndex === 0 && (
            <Text style={styles.title}>
              Teacher Invoice - {safe(filters.EmployeeID)}
            </Text>
          )}

          {/* ══ TABLE ══ */}
          <View
            style={[
              styles.table,
              pageIndex !== 0 && { marginTop: 10 },
            ]}
          >
            <TableHeader />

            {pageData.map((row, rowIndex) => {
              const globalIndex =
                pageIndex === 0
                  ? rowIndex + 1
                  : FIRST_PAGE_COUNT +
                    (pageIndex - 1) * OTHER_PAGE_COUNT +
                    rowIndex +
                    1;

              const empName    = safe(row.EmpName);
              const deptName   = safe(row.DeptName);
              const gender     = safe(row.Gender);
              const mobile     = safe(row.MobileNumber);
              const email      = safe(row.Email);

              return (
                <View
                  key={rowIndex}
                  style={[styles.tableRow, styles.dataRow]}
                >
                  {/* SL# — right align (number) */}
                  <View style={[styles.cellBase, styles.cSlNo]}>
                    <Text style={styles.aRight}>{globalIndex}</Text>
                  </View>

                  {/* Teachers — left align (text) */}
                  <View style={[styles.cellBase, styles.cTeacher]}>
                    <Text style={styles.aLeft}>{empName}</Text>
                  </View>

                  {/* Subjects — left align (text) */}
                  <View style={[styles.cellBase, styles.cSubject]}>
                    <Text style={styles.aLeft}>{deptName}</Text>
                  </View>

                  {/* Gender — center align (category) */}
                  <View style={[styles.cellBase, styles.cGender]}>
                    <Text style={styles.aCenter}>{gender}</Text>
                  </View>

                  {/* Mobile Number — right align (number) */}
                  <View style={[styles.cellBase, styles.cMobile]}>
                    <Text style={styles.aRight}>{mobile}</Text>
                  </View>

                  {/* Email — left align (text), last cell */}
                  <View style={[styles.cellBase, styles.cEmail, styles.lastCell]}>
                    <Text style={styles.aLeft}>{email}</Text>
                  </View>
                </View>
              );
            })}
          </View>

          {/* ══ PAGE NUMBER ══ */}
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />

          {/* ══ FOOTER ══ */}
          <View fixed style={styles.footerWrapper}>
            {filters.FooterImg ? (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                style={styles.footerImage}
              />
            ) : null}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default Teacherspdf;